import styled from "../../../styled/index";
export const LinkTag = styled("a") `
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
`;
//# sourceMappingURL=index.js.map